export default __webpack_public_path__ + "static/media/shape-scale.6d17d42e.PNG";